export const CHECK_AUTH = "checkAuth";
export const FETCH_PROVIDERS = "fetchProviders";
export const LOGOUT = "logout";
export const ISSUES_LOADING_END = "issuesLoadingEnd";
export const ISSUES_LOADING_START = "issuesLoadingStart";

export const SET_ERROR = "setError";
export const ADD_ERROR = "addError";